/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import {
  LocaleCurrencyEvents,
  LocaleCurrencyAnalyticsParams,
} from './localeCurrency.meta';

const BASE_PARAMS = {
  action: LocaleCurrencyEvents.tap,
};

export default {
  [LocaleCurrencyEvents.Currency_Selected]: (
    params: LocaleCurrencyAnalyticsParams,
  ) => ({
    ...BASE_PARAMS,
    category: params.category ?? '',
    label: `choose a currency|${params.previousValue.toLowerCase()}-${params.selectedValue.toLowerCase()}`,
    screen_name: params.screen_name ?? '',
  }),
  [LocaleCurrencyEvents.Language_Selected]: (
    params: LocaleCurrencyAnalyticsParams,
  ) => ({
    ...BASE_PARAMS,
    category: params.category ?? '',
    label: `choose a language|${params.previousValue.toLowerCase()}-${params.selectedValue.toLowerCase()}`,
    screen_name: params.screen_name ?? '',
  }),
};
